<template>
  <span class="lang-toggler">
    <span
      v-for="langItem in languages"
      :key="langItem"
      :class="{'is-selected': langItem === selected}"
      @click="toggle(langItem)"
    >{{ langItem }}</span>
    <span v-if="languages && languages.length > 1" @click="copyCurrentValueToAllLangs" v-tooltip.bottom-center="'copy current value to all languages'">
      <i class="material-icons">flare</i>
    </span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "lang-toggler",
  props: ["lang"],
  created() {
    console.log("lang toggler created");
  },
  data: function() {
    return {
      selected: this.lang
    };
  },
  computed: {
    ...mapGetters(["languages"])
  },
  methods: {
    toggle(value) {
      this.selected = value;
      this.$emit("input", value);
    },
    copyCurrentValueToAllLangs(value) {
      this.$emit("applyAll", this.selected);
    }
  }
};
</script>
